import React from "react";
import PropTypes from "prop-types";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

const AttachmentMenu = ({ anchorEl, onClose, hasFile, onView, onUpdate }) => {
  return (
    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onClose}>
      {hasFile && <MenuItem onClick={onView}>Ver archivo</MenuItem>}
      <MenuItem onClick={onUpdate}>{hasFile ? "Actualizar archivo" : "Subir archivo"}</MenuItem>
    </Menu>
  );
};

AttachmentMenu.propTypes = {
  anchorEl: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  hasFile: PropTypes.bool.isRequired,
  onView: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
};

export default AttachmentMenu;
